import React from "react";
import { Button } from "../../../Atoms";
import { useNavigate } from 'react-router-dom';

const solutions = [
    { label: "Assess your community's need for EV charging",title: "Assess your community's EV charging needs by considering current and projected EV numbers, parking types, usage patterns, and future infrastructure demands", number: 1 },
    { label: "Speak to your electrical contractor",title: "Talk to your electrician about service and panel upgrades", number: 2 },
    { label: "Find out what incentives are available",title: "Discover available incentives & rebates that can lower your costs", number: 3 },
    { label: "Reach out to VerdeMobility to get started",title: "We'll help you choose the right EV charger and guide you through every step, from requirements to installation", number: 4 },
];

const rowLayout = [
    ["55", "45"], // Row 1
    ["45", "55"], // Row 2    
];

const FourSteps = () => {
    const navigate = useNavigate();
    return (
        <section className="bg-light-gradient-white blade-padding-sm">
            <div className="containers-min mx-auto px-4 py-12">
                <div className="2xl:pb-20 xl:pb-16 pb-12">
                    <h3 className="text-center font-gilroy">
                        Steps to make your property EV ready
                    </h3>
                </div>


                {/* Render 3 Rows */}
                <div className="space-y-4 mb-8">
                    {rowLayout.map((layout, rowIndex) => {
                        const first = solutions[rowIndex * 2];
                        const second = solutions[rowIndex * 2 + 1];
                        return (
                            <div key={rowIndex} className="flex flex-col md:flex-row gap-4">
                                <div
                                    className={`bg-gray-200 p-8 rounded-xl flex-1 flex items-center justify-between font-semibold text-left`}
                                    style={{ flexBasis: `${layout[0]}%` }}
                                >
                                    <div className="flex flex-col w-5/6">
                                        <span className="text-2xl font-semibold mb-2 font-gilroy">{first.label}</span>
                                        <span className="text-gray-600 font-normal text-lg font-poppins">{first.title}</span>
                                    </div>
                                    <span className="text-6xl font-bold text-gray-500 w-1/6 text-end font-poppins">{first.number}</span>
                                </div>
                                <div
                                    className={`bg-gray-200 p-6 rounded-xl flex-1 flex items-center justify-between font-semibold text-left`}
                                    style={{ flexBasis: `${layout[1]}%` }}
                                >
                                    <div className="flex flex-col w-5/6">
                                        <span className="text-2xl font-semibold mb-2 font-gilroy">{second.label}</span>
                                        <span className="text-gray-600 text-lg font-normal font-poppins">{second.title}</span>
                                    </div>
                                    <span className="text-6xl font-bold text-gray-500 w-1/6 text-end font-poppins">{second.number}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* CTA Footer */}
                <div className="bg-gradient text-black rounded-xl px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-xl lg:text-2xl font-semibold w-full xl:w-3/4 md:w-3/5 font-poppins">
                        Make your property EV-ready
                    </p>
                    <Button
                        title="Contact Us"
                        onClick={() => navigate('/get-in-touch')}
                    />
                </div>
            </div>
        </section>
    );
};

export default FourSteps;
